import React from 'react';

export interface TextItemLabelProps {
    children: any;
}

const TextItemLabel = ({children}: TextItemLabelProps) => {
    return (
        <div className={`text-item__label`}>
            {children}
        </div>
    )
}

export default TextItemLabel;
